import type { ReactNode } from 'react'

interface KpiCardProps {
  title: string
  value: string | number
  subtitle?: string
  icon: ReactNode
  trend?: { value: number; label: string }
  color?: 'blue' | 'purple' | 'green' | 'red' | 'orange'
}

const COLOR_CLASSES: Record<NonNullable<KpiCardProps['color']>, { icon: string; trend: string }> = {
  blue:   { icon: 'bg-primary-50 text-primary',     trend: 'text-primary' },
  purple: { icon: 'bg-purple-50 text-accent',       trend: 'text-accent' },
  green:  { icon: 'bg-emerald-50 text-emerald-600', trend: 'text-emerald-600' },
  red:    { icon: 'bg-red-50 text-danger',          trend: 'text-danger' },
  orange: { icon: 'bg-orange-50 text-orange-600',   trend: 'text-orange-600' },
}

export function KpiCard({ title, value, subtitle, icon, trend, color = 'blue' }: KpiCardProps) {
  const colors = COLOR_CLASSES[color]

  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm p-5">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-slate-500 dark:text-slate-400">{title}</p>
          <p className="mt-1 text-2xl font-bold text-slate-900 dark:text-slate-100">{value}</p>
          {subtitle && (
            <p className="mt-0.5 text-xs text-slate-400 dark:text-slate-500">{subtitle}</p>
          )}
          {trend && (
            <p className={`mt-1 text-xs font-medium ${colors.trend}`}>
              {trend.value >= 0 ? '+' : ''}{trend.value}% {trend.label}
            </p>
          )}
        </div>
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${colors.icon}`}>
          {icon}
        </div>
      </div>
    </div>
  )
}
